import { render, staticRenderFns } from "./piechart_component.vue?vue&type=template&id=64137e7d"
import script from "./piechart_component.vue?vue&type=script&lang=js"
export * from "./piechart_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports